module.exports = __webpack_public_path__ + "resources/img/img_tcc_advantage4.205c77a5399bd8ab599ba31bb162620d.jpg";